// OpenClipart, CC0 License -> https://openclipart.org/detail/303266/medal
// edited to personal taste

import React from 'react'

type MedalProps = {
  width?: string
  height?: string
}

const Medal: React.FC<MedalProps> = ({width, height}) => (
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 508 508" xmlSpace="preserve" width={width || '512'} height={height || '512'}>
    <g>
      <circle style={{fill:"#fba623"}} cx="253.55" cy="201.7" r="201.7" />
      <g>
        <path style={{fill:"#4d40c8"}} d="M90.15,319.7L20.75,440l81-4.3l36.8,72.3l64.2-111.3C156.75,384.8,117.25,357.1,90.15,319.7z" />
        <path style={{fill:"#4d40c8"}} d="M417.35,319.1c-26.9,37.5-66.4,65.3-112.3,77.4l64.4,111.5l36.8-72.3l81,4.3L417.35,319.1z" />
      </g>
      <circle style={{fill:"#ffbd40"}} cx="253.55" cy="201.7" r="146.2" />
      <path style={{fill:"#ffefb9"}} d="M353.75,185.9c4.5-4.4,2-12.1-4.2-13l-57.7-8.4c-2.5-0.4-4.6-1.9-5.7-4.2l-25.8-52.3  c-2.8-5.7-10.9-5.7-13.7,0l-25.7,52.3c-1.1,2.2-3.3,3.8-5.7,4.2l-57.7,8.4c-6.2,0.9-8.7,8.6-4.2,13l41.7,40.7  c1.8,1.8,2.6,4.3,2.2,6.7l-9.8,57.4c-1.1,6.2,5.5,11,11.1,8l51.6-27.1c2.2-1.2,4.9-1.2,7.1,0l51.6,27.1c5.6,2.9,12.1-1.8,11.1-8  l-9.9-57.4c-0.4-2.5,0.4-5,2.2-6.7L353.75,185.9z"/>
    </g>
  </svg>
)

export default Medal
